import { deburr, flow, toLower } from 'lodash-es';
import { FC } from 'react';

interface IEmphasizeMatchingTextProps {
  searchText: string;
  text?: string;
  children?: string;
}

const sanitize = flow([deburr, toLower]);

export const EmphasizeMatchingText: FC<IEmphasizeMatchingTextProps> = ({ searchText, text, children }) => {
  if (!searchText) {
    return <>{text || children}</>;
  }

  const sanitizedTextToSearch = sanitize(searchText);
  const textToEmphasize = text || children || '';
  const sanitizedTextToEmphasize = sanitize(textToEmphasize);

  const matchIndex = sanitizedTextToEmphasize.indexOf(sanitizedTextToSearch);

  return matchIndex < 0 ? (
    <>{text || children}</>
  ) : (
    <>
      {textToEmphasize.slice(0, matchIndex)}
      <strong>{textToEmphasize.slice(matchIndex, matchIndex + searchText.length)}</strong>
      {textToEmphasize.slice(matchIndex + searchText.length)}
    </>
  );
};
